import "./Pagination.css";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 0) {
    return (
      <div className="admin-pagination">
        <button className="admin-page-btn active">1</button>
      </div>
    );
  }

  const pageGroupSize = 10;
  const groupStart = Math.floor(currentPage / pageGroupSize) * pageGroupSize;
  const groupEnd = Math.min(groupStart + pageGroupSize - 1, totalPages - 1);

  return (
    <div className="admin-pagination">
      <button
        className="admin-page-btn"
        onClick={() => onPageChange(0)}
        disabled={currentPage === 0}
      >
        처음
      </button>
      <button
        className="admin-page-btn"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 0}
      >
        이전
      </button>
      <div className="admin-page-numbers">
        {Array.from({ length: groupEnd - groupStart + 1 }, (_, i) => groupStart + i).map((page) => (
          <button
            key={page}
            className={`admin-page-btn ${currentPage === page ? "active" : ""}`}
            onClick={() => onPageChange(page)}
          >
            {page + 1}
          </button>
        ))}
      </div>
      <button
        className="admin-page-btn"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages - 1}
      >
        다음
      </button>
      <button
        className="admin-page-btn"
        onClick={() => onPageChange(totalPages - 1)}
        disabled={currentPage === totalPages - 1}
      >
        마지막
      </button>
    </div>
  );
};

export default Pagination;
